/** Shared enums / literal unions used across server (DB, tRPC) and client. */
export const LOGIN_METHODS = ['email', 'facebook'];
/** Connections are reusable credentials/channels. */
export const CONNECTION_TYPES = ['facebook', 'telegram', 'google', 'webhook'];
export const CONNECTION_STATUS = ['active', 'needs_attention', 'disconnected', 'unverified'];
/** Categories shown in the destination/app picker. */
export const APP_CATEGORIES = ['webhook', 'crm', 'affiliate'];
/** Built-in connector/app keys (a "destination type"). HTTP-only after the
 *  Telegram and Google Sheets destination types were removed in the lean-down. */
export const APP_KEYS = ['webhook', 'cpa_generic'];
/** Lifecycle of a captured lead. */
export const LEAD_STATUS = ['pending', 'received', 'failed'];
/** Lifecycle of a single delivery (one lead × one destination) — called an "order".
 *  - pending / sent / failed: delivery transport state set by deliveryWorker
 *  - add_to_cart / purchased / cancelled: downstream conversion state set by the
 *    operator (or an upstream CRM webhook), used to drive Facebook CAPI events. */
export const ORDER_STATUS = ['pending', 'sent', 'failed', 'add_to_cart', 'purchased', 'cancelled'];
/** Subset of ORDER_STATUS that we send to Facebook CAPI as a conversion event. */
export const CAPI_STAGES = ['delivered', 'add_to_cart', 'purchased', 'cancelled'];
/** Conversion-event delivery state (rows in conversion_events). */
export const CONVERSION_EVENT_STATUS = ['pending', 'sent', 'failed'];
export const TRIGGER_TYPES = ['webhook', 'manual', 'schedule'];
export const WORKFLOW_STEP_TYPES = [
    'trigger',
    'condition',
    'http_request',
    'telegram',
    'set_variable',
    'transform',
];
export const EXECUTION_STATUS = ['pending', 'running', 'succeeded', 'failed'];
/** DynamicForm field kinds (config UIs are rendered from JSON schemas). */
export const FORM_FIELD_TYPES = [
    'text',
    'textarea',
    'number',
    'password',
    'select',
    'multiselect',
    'async-select',
    'boolean',
    'code',
    'group',
    'repeatable',
    'hidden',
    'field-mapping',
    'connection-picker',
];
/** Lead metadata variables available for `{{placeholder}}` expressions in destination payloads. */
export const LEAD_VARIABLES = [
    'lead.id',
    'lead.createdAt',
    'lead.fullName',
    'lead.firstName',
    'lead.lastName',
    'lead.email',
    'lead.phone',
    'lead.formId',
    'lead.formName',
    'lead.pageId',
    'lead.pageName',
    'lead.adId',
    'lead.adName',
    'lead.adsetId',
    'lead.adsetName',
    'lead.campaignId',
    'lead.campaignName',
];
export const HTTP_METHODS = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'];
/** Comparison operators for destination filters / workflow conditions. */
export const FILTER_OPERATORS = [
    'eq',
    'neq',
    'contains',
    'not_contains',
    'starts_with',
    'ends_with',
    'is_empty',
    'is_not_empty',
    'gt',
    'lt',
    'in',
    'not_in',
];
/**
 * Delivery retry policy. Exponential backoff so a transient CRM outage doesn't
 * dead-letter every queued lead within a single hour:
 *
 *   attempt N fails → BullMQ waits DELIVERY_RETRY_DELAY_MS × 2^attemptsMade → attempt N+1
 *
 * Worst-case time from the first attempt to DLQ with base=5min and 7 retries
 * is ~10+20+40+80+160+320+640 min ≈ 21 hours — enough to survive an overnight
 * CRM outage. `DELIVERY_STUCK_THRESHOLD_MS` is set wider than the largest gap
 * so the stuck-scan does not re-enqueue jobs whose retry is still pending.
 */
export const DELIVERY_MAX_ATTEMPTS = 7;
export const DELIVERY_RETRY_DELAY_MS = 5 * 60 * 1000;
export const DELIVERY_STUCK_THRESHOLD_MS = 12 * 60 * 60 * 1000;
/** Per-request HTTP timeout for outbound CRM deliveries (overridable via env). */
export const DELIVERY_HTTP_TIMEOUT_MS_DEFAULT = 30 * 1000;
export const SESSION_COOKIE_NAME = 'app_session_id';
//# sourceMappingURL=constants.js.map